import { getParams } from "./geParams";
import { log } from "./log";
import { saveParams } from "./save-params";

export function applyUTMsToLinks({ debug = false }: { debug?: boolean }) {
  const params = getParams();
  if (!params) return;

  document.querySelectorAll("a[href]")?.forEach((el) => {
    const a = el as HTMLAnchorElement;

    try {
      if (
        a.href.startsWith("mailto:") ||
        a.href.startsWith("tel:") ||
        a.href.startsWith("#")
      ) {
        return;
      }

      const url = new URL(a.href);

      for (const key in params) {
        if (params[key]) {
          url.searchParams.set(key, params[key]);
        }
      }

      a.href = url.toString();
    } catch {
      // Ignora URLs inválidas
    }
  });

  log({
    debug,
    message: "UTMs aplicados aos links",
    data: {
      params,
    },
  });
}

export function applyUTMsToForms({ debug = false }: { debug?: boolean }) {
  const params = getParams();
  if (!params) return;

  document.querySelectorAll("form")?.forEach((form) => {
    for (const key in params) {
      if (params[key]) {
        const alreadyExists = form.querySelector(`input[name="${key}"]`);
        if (!alreadyExists) {
          const hidden = document.createElement("input");
          hidden.type = "hidden";
          hidden.name = key;
          hidden.value = params[key];
          form.appendChild(hidden);
        }
      }
    }
  });
}

export function applyUTMsToLinksAndForms({
  debug = false,
}: {
  debug?: boolean;
}) {
  saveParams({ debug });
  applyUTMsToLinks({ debug });
  applyUTMsToForms({ debug });
}
